/**
 * The tento-ui seam's `LiveData` values as `Option`: tento-ui-js publishes
 * readables whose ambient `Option` admits `undefined` (`ScrollPort.pointerPosition`,
 * `TimelineLayoutManager.hoveredDate`); the sheets-ui surfaces that hand them
 * on publish `Option<T>` (`T | null`) only, so the value is adapted once, here.
 */
import type { Option } from "@tento-lona/sheets";
import type { LiveData } from "@tento-core/livedata";

/**
 * A read-only view of `source` whose value (and every listener's value and
 * previous value) is `Option<T>`: `undefined` reads as `null`. Listeners are
 * registered on `source` under the caller's target, so `removeListener`
 * removes them there.
 */
export function optionLiveData<T>(
  source: LiveData.Readable<T | null | undefined>,
): LiveData.Readable<Option<T>> {
  return {
    get: () => source.get() ?? null,
    addListener: (target, cb, trigger) => {
      source.addListener(
        target,
        (value, prev, key) => cb(value ?? null, prev ?? null, key ?? null),
        trigger ?? null,
      );
    },
    removeListener: (target) => source.removeListener(target),
  };
}
